import { useMutation, useQuery } from "react-query"
import { useMainContext } from "../../../modules/Dashboard"
import { normalFetch } from "../../../core/services/fetch-api/get"
import { postApi, postApiWithToken } from "../../../core/services/fetch-api/post"
import { useQueryContext } from "../../../core/contexts/query"

export const useGetAllPlans = () => {
    const {
        profile: { token },
    } = useMainContext()

    return useQuery(
        ['plans-list'],
        () => normalFetch(token, `settings/package?isAll=true`),
        {
            select: (res) => res?.data?.data,
            refetchOnWindowFocus: false,

        }
    )
}

export const useBuyPackage = (onError, onSuccess) => {
    const {
        profile: { token },
    } = useMainContext()
    const { queryClient } = useQueryContext()



    return useMutation('buy-package', (data) => postApiWithToken(data, token, 'packages'), {
        select: (res) => res.data,
        onSuccess: () => {
            onSuccess()
            queryClient.invalidateQueries('user-current-package')
        },
        onError
    })
}

export const useGetUserPackage = (packageId) => {
    const {
        profile: { token },
    } = useMainContext()

    return useQuery(
        ['user-current-package'],
        () => normalFetch(token, `profile/package`),
        {
            select: (res) => res?.data?.data,
            refetchOnWindowFocus: false,
        }
    )
}